<script setup lang="ts">
defineProps<{pending: boolean}>()
</script>

<template>
  <div>
    <div v-if="pending">{{ pending }}</div>
    <slot v-else />
  </div>
</template>
